module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/february-c9f635039b9b01f81c3ce4a957177450.png";